import script from "./VCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./VCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./VCheckbox.vue?vue&type=style&index=0&id=7cb892d3&lang=sass"

const __exports__ = script;

export default __exports__